import { Answer } from "src/app/models/answer.model";
export class Question{
    id:string
    text:string
    correctAnswerId:string
    score:number
    answers:Answer[]
    studentAnswer:string = ''
}